<template>
<div>
    <columns>
      <column @click="showFindings = !showFindings">
        <checkpoint-heading 
          class="pointer"
          :title="checkpoint.value"
          :checkpoint-index="checkpointIndex"
          :unresolved-findings-count="unresolvedFindings.length"
        />
      </column>
      <column class="is-narrow">
        <compliance-status 
          :risk-level="checkpoint.risk_level"
          :unresolved-findings="unresolvedFindings.length"
        />
      </column>
    </columns>

    <transition name="fade">
      <columns v-if="showFindings">
        <column>

          <h5 class="title is-5">{{ unresolvedFindings.length }} Finding<span v-if="unresolvedFindings.length !== 1">s</span></h5>          

          <div
            v-for="finding in unresolvedFindings" 
            :key="finding.id">
            
            <component 
              v-if="finding.finding"
              :is="`audit-checkpoint-finding-${finding.finding.findable_type}`"
              :finding="finding.finding"
            />

            <span class="has-text-danger" v-else>
              {{ finding.value }}
            </span>
          </div>
        </column>
      </columns>
    </transition>

</div>
</template>
<script>
import CheckpointHeading from './Heading.vue'
import ComplianceStatus from './ComplianceStatus.vue'
import './Findings/install'

export default {

  components: {
    CheckpointHeading,
    ComplianceStatus
  },
  
  props: {
    checkpointIndex: {
      type: Number,
      default: 0
    },
    checkpoint: {
      type: Object,
      default: () => ({

      })
    },
    findings: {
      type: Array,
      default: () => ([])
    }
  },

  data: () => ({
    showFindings: false
  }),

  computed: {
    unresolvedFindings() {
      return this.findings.filter(finding => finding.is_compliant === false)
    }
  }

}
</script>